// import React, { useMemo } from "react";
// import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import MCA from "../assets/CourseBannerimmage/MCA.svg";
import MBA from "../assets/CourseBannerimmage/MBA.svg";
import BCA from "../assets/CourseBannerimmage/BCA.svg";
import BBA from "../assets/CourseBannerimmage/BBA.svg";
import LLB from "../assets/CourseBannerimmage/LAW.webp";
import Med from "../assets/CourseBannerimmage/Med.svg";
import Bed from "../assets/CourseBannerimmage/Bed.svg";
import BCAGU from "../assets/CourseBannerimmage/BCAGU.svg";
import BscNursingGU from "../assets/CourseBannerimmage/BscNursingGU.svg";
import PostBasicBscNursingGU from "../assets/CourseBannerimmage/PostBasicBscNursingGU.svg";
import GNMNursingGU from "../assets/CourseBannerimmage/GNMNursingGU.svg";
import Bcom from "../assets/CourseBannerimmage/Bcom.svg";
import Mcom from "../assets/CourseBannerimmage/Mcom.svg";
import Book from "../assets/CourseBannerimmage/BOOK.jpg";
import { useSelector } from "react-redux";
import { useMemo } from "react";

const courseImages = {
  mca_gtu: MCA,
  mba_gtu: MBA,
  bca_gtu: BCA,
  bba_gtu: BBA,
  llb_gu: LLB,
  med_gu: Med,
  bed_gu: Bed,
  bca_gu: BCAGU,
  bscnursing_gu: BscNursingGU,
  postbasicbscnursing_gu: PostBasicBscNursingGU,
  gnmnursing_gu: GNMNursingGU,
  bcom_gu: Bcom,
  mcom_gu: Mcom,
};

const getCourseImage = (course) => {
  const key = `${course?.course_name.replace(/\s+/g, "").replace(/\./g, "")}_${course?.college_type
    }`;
  return courseImages[key?.toLowerCase()] || Book;
};

const CollegeCard = ({ course }) => {
  // const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, x: 30 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.9 }}
    >
      <motion.div
        key={course.id}
        // onClick={() =>
        //   navigate(
        //     `/academics/${course?.college_id}/${course?.course_name}/${course?.id}`
        //   )
        // }
        className="border justify-around border-primary flex flex-col items-center rounded-lg shadow-md bg-white cursor-pointer p-2 sm:h-64 h-32"
        whileHover={{
          scale: 1.05,
          boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <div className="overflow-hidden rounded-lg w-full">
          <motion.img
            src={getCourseImage(course)}
            alt={course?.course_name}
            className="w-full sm:h-40 max-[400px]:h-14 max-[350px]:h-10 max-sm:h-16 object-contain block"
            whileHover={{ scale: 1.1 }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          />
        </div>
        <motion.h4
          className={`mt-3 sm:text-lg text-xs font-semibold text-center text-gray-700`}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {course?.course_name}
        </motion.h4>
      </motion.div>
    </motion.div>
  );
};

function OfferedCoursesSection() {
  // const { allCourses } = useSelector(State => State.courses);
  // console.log(allCourses)
  // const gtuColleges = useMemo(
  //   () =>
  //     allCourses.filter((college) => college?.college_type === "GTU"),
  //   [allCourses]
  // );

  // const guColleges = useMemo(
  //   () =>
  //     allCourses.filter((college) => college?.college_type === "GU"),
  //   [allCourses]
  // );
  const guCourses = [
    {
      id: 27,
      college_id: 10,
      college_name: "Lokmanya College of Education",
      college_type: "GU",
      course_name: "M.Ed",
      course_banner_images: [],
      created_at: "2025-03-18T05:53:19.739Z",
      updated_at: "2025-03-18T06:06:24.830Z"
    },
    {
      id: 15,
      college_id: 2,
      college_name: "Lokmanya College of Nursing Education and Research",
      college_type: "GU",
      course_name: "B.Sc Nursing",
      course_banner_images: [
        { id: 29, resue: "16:9" },
        { id: 30, resue: "1:1" }
      ],
      created_at: "2025-02-12T12:16:04.221Z",
      updated_at: "2025-04-04T08:07:00.508Z"
    },
    {
      id: 14,
      college_id: 3,
      college_name: "Lokmanya college of commerce",
      college_type: "GU",
      course_name: "M.Com",
      course_banner_images: [
        { id: 27, resue: "16:9" },
        { id: 28, resue: "1:1" }
      ],
      created_at: "2025-02-12T12:14:10.069Z",
      updated_at: "2025-03-13T03:45:36.553Z"
    },
    {
      id: 13,
      college_id: 12,
      college_name: "Lokmanya College of Law",
      college_type: "GU",
      course_name: "L.L.B",
      course_banner_images: [
        { id: 13, resue: "16:9" },
        { id: 14, resue: "1:1" }
      ],
      created_at: "2025-02-12T08:29:55.979Z",
      updated_at: "2025-02-12T08:29:55.979Z"
    },
    {
      id: 11,
      college_id: 10,
      college_name: "Lokmanya College of Education",
      college_type: "GU",
      course_name: "B.Ed",
      course_banner_images: [
        { id: 5, resue: "1:1" },
        { id: 10, resue: "16:9" }
      ],
      created_at: "2025-02-12T08:28:16.758Z",
      updated_at: "2025-03-13T03:46:08.395Z"
    },
    {
      id: 6,
      college_id: 5,
      college_name: "Lokmanya college of Computer Application",
      college_type: "GU",
      course_name: "B.C.A",
      course_banner_images: [
        { id: 23, resue: "16:9" },
        { id: 24, resue: "1:1" }
      ],
      created_at: "2025-02-12T08:26:20.246Z",
      updated_at: "2025-02-12T08:26:20.246Z"
    },
    {
      id: 4,
      college_id: 3,
      college_name: "Lokmanya college of commerce",
      college_type: "GU",
      course_name: "B.Com",
      course_banner_images: [
        { id: 25, resue: "16:9" },
        { id: 26, resue: "1:1" }
      ],
      created_at: "2025-02-12T08:25:21.274Z",
      updated_at: "2025-03-13T03:45:36.559Z"
    },
    {
      id: 3,
      college_id: 2,
      college_name: "Lokmanya College of Nursing Education and Research",
      college_type: "GU",
      course_name: "GNM Nursing",
      course_banner_images: [
        { id: 8, resue: "16:9" },
        { id: 9, resue: "1:1" }
      ],
      created_at: "2025-02-12T07:24:25.382Z",
      updated_at: "2025-02-12T07:24:25.382Z"
    },
    {
      id: 2,
      college_id: 2,
      college_name: "Lokmanya College of Nursing Education and Research",
      college_type: "GU",
      course_name: "Post Basic B.Sc Nursing",
      course_banner_images: [
        { id: 6, resue: "16:9" },
        { id: 7, resue: "1:1" }
      ],
      created_at: "2025-02-12T07:24:25.350Z",
      updated_at: "2025-04-04T08:07:00.556Z"
    }
  ];
  // const gtuCourses = [
  //   {
  //     id: 26,
  //     college_id: 7,
  //     college_name: "Lokmanya BBA BCA college",
  //     college_type: "GTU",
  //     course_name: "B.B.A.",
  //     course_banner_images: [
  //       { id: 33, resue: "16:9" }
  //     ],
  //     created_at: "2025-03-15T07:02:38.638Z",
  //     updated_at: "2025-03-15T07:02:52.162Z"
  //   },
  //   {
  //     id: 24,
  //     college_id: 9,
  //     college_name: "lokmanya institute of management and computer application",
  //     college_type: "GTU",
  //     course_name: "M.B.A",
  //     course_banner_images: [
  //       { id: 31, resue: "16:9" },
  //       { id: 32, resue: "1:1" }
  //     ],
  //     created_at: "2025-03-13T04:38:32.006Z",
  //     updated_at: "2025-03-13T04:38:32.006Z"
  //   },
  //   {
  //     id: 10,
  //     college_id: 9,
  //     college_name: "lokmanya institute of management and computer application",
  //     college_type: "GTU",
  //     course_name: "M.C.A",
  //     course_banner_images: [
  //       { id: 21, resue: "16:9" },
  //       { id: 22, resue: "1:1" }
  //     ],
  //     created_at: "2025-02-12T08:27:56.467Z",
  //     updated_at: "2025-02-12T08:27:56.467Z"
  //   },
  //   {
  //     id: 8,
  //     college_id: 7,
  //     college_name: "Lokmanya BBA BCA college",
  //     college_type: "GTU",
  //     course_name: "B.C.A",
  //     course_banner_images: [
  //       { id: 19, resue: "16:9" },
  //       { id: 20, resue: "1:1" }
  //     ],
  //     created_at: "2025-02-12T08:27:12.578Z",
  //     updated_at: "2025-02-12T08:27:12.578Z"
  //   }
  // ];

  return (
    <div id="academics" className="py-16 px-4 sm:px-8 lg:px-16 bg-white">
      <div className="sm:mb-6 mb-2 border-b-2 border-primary pb-4">
        <h1 className="sm:text-4xl text-2xl font-bold text-primary capitalize">
          Offered Courses
        </h1>
        <p className="sm:text-lg text-sm text-gray-600 mt-2">
          Committed to transformative learning, leadership, and enduring impact.
        </p>
      </div>

      <div className="container mx-auto">
        {/* GTU Affiliated Colleges */}
        {/* {gtuColleges.length > 0 && ( */}
        {/* <div className="sm:mt-10 mt-2 overflow-hidden">

          <h2 className="sm:text-3xl text-xl font-semibold text-secondary sm:mb-6 mb-2">
            Affiliated with GTU
          </h2>
          <motion.div
            className="grid grid-cols-3 lg:grid-cols-4 sm:gap-6 gap-2 sm:p-8 px-4"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            {gtuCourses?.map((course) => (
              <CollegeCard key={course.id} course={course} />
            ))}
          </motion.div>
        </div> */}
        {/* )} */}

        {/* GU Affiliated Colleges */}
        {/* {guColleges.length > 0 && ( */}
        <div className="sm:mt-16 mt-2 overflow-hidden">
          {/* <h2 className="sm:text-3xl text-xl font-semibold text-secondary sm:mb-6 mb-2">
            Affiliated with GU
          </h2> */}
          <motion.div
            className="grid grid-cols-3 lg:grid-cols-4 sm:gap-6 gap-3 sm:p-8 px-4"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            {guCourses?.map((course) => (
              <CollegeCard key={course.id} course={course} />
            ))}
          </motion.div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
}

export default OfferedCoursesSection;
